

define(['jquery', 'squid/index', 'text!./template.html'], function ($, squid, template) {

    squid.module('xo-aside-header.directive', ['squid']).directive('xoAsideHeader', function () {
        return {
            template: template,
            restrict: 'E',
            scope: {
                hdrtype: '@',
                heading: '@',
                subHead: '@',
                addLink: '@',
                backUrl: '@',
                closeUrl: '@',
                hidex: '@',
                headerLeftLink: '=',
                headerLeft: '@',
                headerLeftIcon: '@',
                headerRightLink: '=',
                headerRight: '@',
                headerRightIcon: '@',
                subHeaderLeftLink: '@',
                subHeaderLeft: '@',
                subHeaderLeftIcon: '@',
                subHeaderRightLink: '@',
                subHeaderRight: '@',
                subHeaderRightIcon: '@',
                showDualFi: '='
            },
            controller: function controller($scope, $element, $state, $timeout) {
                $timeout(function () {
                    $element.find('.header').focus();
                });

                if (angular.isUndefined($scope.closeUrl)) {
                    $scope.closeUrl = 'checkout.review';
                }

                if ($scope.addLink) {
                    $scope.subHeaderRight = 'asideHeader.add';
                    $scope.subHeaderRightLink = $scope.addLink;
                }

                $scope.onClickLink = function (event, target, showDualFi) {
                    event.preventDefault();
                    if (showDualFi) {
                        $scope.showFiOptions = true;
                    } else if (angular.isFunction(target)) {
                        target();
                    } else {
                        $state.go(target);
                    }
                };
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/aside-header/directive.js
// module id = ./components/xo-page-components/src/aside-header/directive.js
// module chunks = 1